import { ArrowUpRight, MessageCircle } from "lucide-react";
import { MODELS, buildWhatsAppUrl } from "../../lib/constants";
import { trackEvent } from "../../lib/api";

export default function Models() {
  const scrollToForm = (typeKey, title) => {
    trackEvent("model_cta_click", { model: typeKey });
    const el = document.getElementById("cotiza");
    if (el) {
      window.dispatchEvent(new CustomEvent("vt:preselectProjectType", { detail: { typeKey, title } }));
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="tipos" data-testid="models-section" className="bg-[#F2F4ED] text-[#1F2937] section-pad">
      <div className="container-tight">
        <div className="flex items-center gap-3 mb-4">
          <span className="divider-accent" />
          <span className="kicker">Tipos de velaria</span>
        </div>
        <h2 className="font-display font-black tracking-tightest text-4xl md:text-5xl lg:text-6xl max-w-3xl">
          Una solución para cada <span className="text-accent">espacio</span>.
        </h2>
        <p className="mt-6 max-w-2xl text-[#1F2937]/70 text-base md:text-lg">
          Diseñamos cada proyecto desde cero según las necesidades de tu espacio, clima y uso.
        </p>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {MODELS.map((m, i) => (
            <article
              key={m.id}
              className={`group relative overflow-hidden border border-[#DDE2D5] hover:border-accent transition-colors ${
                i === 3 ? "lg:col-start-1" : ""
              }`}
              data-testid={`model-card-${m.id}`}
            >
              <div className="relative aspect-[4/5] img-zoom-wrap">
                <img
                  src={m.img}
                  alt={m.title}
                  loading="lazy"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-eclipse via-eclipse/20 to-transparent" />
                <div className="absolute inset-0 bg-accent/0 group-hover:bg-accent/85 transition-colors duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100">
                  <span className="flex items-center gap-2 text-white font-display font-black uppercase tracking-wider text-sm">
                    Cotizar este tipo <ArrowUpRight className="w-5 h-5" />
                  </span>
                </div>

                {/* Badge */}
                <span className="absolute top-4 left-4 bg-eclipse/90 border border-accent/60 text-accent font-mono text-[10px] uppercase tracking-[0.2em] px-3 py-1.5">
                  {m.badge}
                </span>

                {/* Copy */}
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="font-display font-black uppercase tracking-tight text-[#1F2937] text-xl md:text-2xl leading-tight">
                    {m.title}
                  </h3>
                  <p className="mt-2 text-[#1F2937]/80 text-sm">{m.desc}</p>
                  <p className="mt-2 text-[#1F2937]/60 text-xs italic">{m.useCase}</p>
                </div>
              </div>

              <button
                onClick={() => scrollToForm(m.projectTypeKey, m.title)}
                className="w-full py-4 flex items-center justify-between px-6 border-t border-[#DDE2D5] group-hover:bg-accent group-hover:text-white transition-colors"
                data-testid={`model-cta-${m.id}`}
              >
                <span className="font-display font-bold uppercase tracking-wider text-xs">
                  Cotizar este tipo
                </span>
                <ArrowUpRight className="w-4 h-4" />
              </button>
            </article>
          ))}
        </div>

        {/* CTA intermedio */}
        <div className="mt-16 border border-[#DDE2D5] p-8 md:p-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 bg-[#F2F4ED]">
          <div>
            <h3 className="font-display font-black text-2xl md:text-3xl text-[#1F2937] tracking-tight">
              ¿No sabes qué tipo necesitas?
            </h3>
            <p className="mt-2 text-[#1F2937]/70">
              Nuestros ingenieros te asesoran sin costo.
            </p>
          </div>
          <a
            href={buildWhatsAppUrl("Hola, necesito asesoría para saber qué tipo de velaria me conviene.")}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent("cta_whatsapp_click", { location: "models_advice" })}
            className="btn-accent"
            data-testid="models-advice-cta"
          >
            <MessageCircle className="w-4 h-4" /> Habla con un ingeniero
          </a>
        </div>
      </div>
    </section>
  );
}
